exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js??ref--7-1!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!v-calendar/lib/v-calendar.min.css"), "");

// module
exports.push([module.id, "\n.back_link[data-v-1c8c439e] {\n    color: #00aced;\n    font-size: 13px;\n    align-self: flex-end;\n}\n", ""]);

// exports
